











import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PuzzleGrid from '@/components/PuzzleGrid.vue';
import WordList from '@/components/WordList.vue';
import WordListMobile from '@/components/WordListMobile.vue';
import ResizeObserver from 'resize-observer-polyfill';
import { isIOS, isMobile, isTablet } from 'mobile-device-detect';

const puzzle = namespace('Puzzle');

@Component({
  components: {
    PuzzleGrid,
    WordList,
    WordListMobile,
  },
})
export default class GameArea extends Vue {
  @puzzle.Mutation
  private setGridSize!: (size: number) => void;

  private resizeObserver: ResizeObserver | null = null;

  private verticalLayout = false;

  private rotateStyle = ``;

  public mounted() {
    if (this.resizeObserver) return;
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.$refs.gameArea as HTMLElement);
  }

  public destroyed() {
    if (this.resizeObserver !== null) this.resizeObserver.disconnect();
  }

  private handleResize() {
    const { innerWidth, innerHeight } = window;
    const root = this.$refs.gameArea as HTMLElement;
    this.verticalLayout = isMobile || innerWidth < innerHeight;
    this.resizeWords();
    if (isMobile && innerWidth > innerHeight) return;
    let maxGridSize = this.verticalLayout ? innerHeight * 0.55 - 50 : Math.min(innerWidth, innerHeight) * 0.7;
    if (maxGridSize >= innerWidth) maxGridSize = innerWidth - 30;
    this.setGridSize(Math.min(maxGridSize, root.clientWidth));
  }

  resizeWords() {
    setTimeout(() => {
      const wordContainer = document.getElementsByClassName('wordList--columnWrapper')[0] as HTMLElement;
      if (wordContainer) {
        let initialFontSize = 1;
        if (isTablet || (innerWidth / innerHeight * 100 > 64 && !isIOS)) {
          initialFontSize = 1.5;
        }
        wordContainer.style.fontSize = `${initialFontSize}em`;
        const elements = document.getElementsByClassName('word');
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          if (element) {
            let ratio = element.scrollWidth / element.clientWidth;
            if (ratio > 1) {
              ratio *= 1.1;
              wordContainer.style.fontSize = `${initialFontSize / ratio}em`;
            }
          }
        }
      }
    }, 20);
  }

  get gameAreaStyle() {
    if (this.verticalLayout) {
      return `
        display: block;
      `;
    }

    return `
      display: flex;
      justify-content: center;
    `;
  }
}
